/**
 * Deli meats data
 * Represents meats available by weight at the deli counter
 */

const deliMeats = [
  {
    id: 1,
    name: "Soft Salami",
    category: "meats"
  },
  {
    id: 2,
    name: "Medium Salami",
    category: "meats"
  },
  {
    id: 3,
    name: "Hard Salami",
    category: "meats"
  },
  {
    id: 4,
    name: "White Turkey Breast",
    category: "meats"
  },
  {
    id: 5,
    name: "Smoked Turkey Breast",
    category: "meats"
  },
  {
    id: 6,
    name: "Turkey Pastrami",
    category: "meats"
  },
  {
    id: 7,
    name: "Corned Beef",
    category: "meats",
    description: "Regular & Lean"
  },
  {
    id: 8,
    name: "Pastrami",
    category: "meats",
    description: "Regular & Lean"
  },
  {
    id: 9,
    name: "Rare Roast Beef*",
    category: "meats"
  },
  {
    id: 10,
    name: "Brisket Roast Beef",
    category: "meats"
  },
  {
    id: 11,
    name: "Chopped Liver",
    category: "meats"
  },
  {
    id: 12,
    name: "Beef Tongue",
    category: "meats",
    description: "Regular (Flat) & Lean (Tip)"
  },
  {
    id: 13,
    name: "Beef Hot Dogs",
    category: "meats"
  },
  {
    id: 14,
    name: "Bologna",
    category: "meats"
  },
  {
    id: 15,
    name: "Liverwurst",
    category: "meats"
  },
  {
    id: 16,
    name: "Bavarian Ham",
    category: "meats"
  },
  {
    id: 17,
    name: "Bacon",
    category: "meats"
  }
];

module.exports = deliMeats;
